const ExtractRouteParams = (): string => {
	const urlElements = window.location.href.split("?");

	return urlElements[1];
};

export default ExtractRouteParams;
